// extracted by mini-css-extract-plugin
export default {"button":"adminButtons-module_button__hpaSl","black":"adminButtons-module_black__NXenc adminButtons-module_button__hpaSl"};